// <reference path="../../../../Scripts/typings/durandal/durandal.d.ts" />
/// <reference path="../../../../Scripts/typings/knockout.es5/knockout.es5.d.ts" />
/// <reference path="../../../../Scripts/typings/toastr/toastr.d.ts" />
/// <reference path="../../../../Scripts/typings/q/q.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/organizationmanager/viewmodels/changeurl',["require", "exports", "plugins/dialog", "common/viewmodelbase", "services/trace", "services/httpclient"], function (require, exports, dialog, vm, trace, http) {
    "use strict";
    var ChangeUrlViewModel = (function (_super) {
        __extends(ChangeUrlViewModel, _super);
        function ChangeUrlViewModel() {
            _super.call(this);
            this.title = $.t("app:modules.organizationmanager.headline_title", { ifMissing: "Change Url" });
            ko.track(this, ['newUri']);
        }
        ChangeUrlViewModel.prototype.onActivated = function (context) {
            this.organizationId = context.callingParameters.get("unknown");
        };
        ChangeUrlViewModel.prototype.changeUri = function () {
            var _this = this;
            var channel = new http.Channel();
            channel.postData("/api/organizationuri/saveorganizationuri?organizationId=" + this.organizationId + "&newUri=" + this.newUri, http.ServiceTarget.portalApi, null).
                then(function (resultData) {
                var changeUrlSuccess = $.t("app:modules.organizationmanager.message_changeUrlSuccess", { ifMissing: "Das Setzen der neuen Uri wurde erfolgreich abgeschlossen." });
                trace.traceInformation(changeUrlSuccess);
            }).fail(function (exceptionGeneration) {
                var errorMessage = _this.readErrorMessage(exceptionGeneration);
                var changeUrlFailure = $.t("app:modules.organizationmanager.message_changeUrlFailure", { ifMissing: "Fehler beim Setzen der Uri " });
                trace.traceError(changeUrlFailure + errorMessage, null, "changeurl: organizationmanager", true);
                dialog.close(_this);
            }).done(function () {
                dialog.close(_this);
            });
        };
        ChangeUrlViewModel.prototype.cancel = function () {
            dialog.close(this);
        };
        ChangeUrlViewModel.prototype.readErrorMessage = function (error) {
            try {
                var errorMessage = error.responseJSON.Message;
                return errorMessage;
            }
            catch (exception) {
                return JSON.stringify(error);
            }
        };
        return ChangeUrlViewModel;
    }(vm.ViewModelBase));
    return ChangeUrlViewModel;
});

